import React, { PropsWithChildren, ReactElement } from 'react';
import { StyledTableTopButtons } from './styles';

const TableTopButtons = ({ children }: PropsWithChildren): ReactElement => (
  <StyledTableTopButtons>{children}</StyledTableTopButtons>
);

export { TableTopButtons };
